import { useQuery } from "@tanstack/react-query";
import { getUserBettingRules } from "@/api/bettingRules";
import { BettingRulesQueryKeys } from "./bettingRulesQueryKeys";

export const useUserBettingRules = () => {
  return useQuery({
    queryKey: [BettingRulesQueryKeys.UserBettingRules],
    queryFn: ({ signal }) => getUserBettingRules({ signal }),
  });
};
